<template>
  <div class="flex-1 flex flex-col">
    <q-tabs
      v-model="tab"
      dense
      stretch
      active-color="primary-pure"
      class="!w-full !h-44"
    >
      <q-tab name="pergunta" :label="t('question')" class="w-full" />
      <q-tab
        name="niveis"
        :label="t('maturityLevels')"
        class="w-full"
      />
    </q-tabs>

    <q-separator />

    <div class="flex-1 overflow-y-auto">
      <TabPerguntaEdit
        v-show="tab === 'pergunta'"
        ref="perguntaRef"
        :initial-pergunta
        @change:pergunta="$emit('change:pergunta', $event)"
      />

      <TabNiveisMaturidade
        v-show="tab === 'niveis'"
        ref="niveisRef"
        :initial-niveis
        @change:alternativas="$emit('change:alternativas', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import TabNiveisMaturidade from 'components/Tabs/TabNiveisMaturidade.vue'
import TabPerguntaEdit from 'components/Tabs/TabPerguntaEdit.vue'

const { t } = useI18n()

const props = defineProps({
  modelValue: { type: String, default: 'pergunta' },
  initialPergunta: { type: Object, default: () => ({}) },
  initialNiveis: { type: Array, default: () => [] },
})

const tab = ref(props.modelValue)
watch(tab, (v) => emit('update:modelValue', v))

const perguntaRef = ref(null)
const niveisRef = ref(null)

const validate = async () => {
  const perguntaValid = await perguntaRef.value?.validate()
  const niveisValid = await niveisRef.value?.validate()
  return perguntaValid && niveisValid
}

const emit = defineEmits([
  'update:modelValue',
  'change:pergunta',
  'change:alternativas',
])

defineExpose({ validate })
</script>
